import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var XlsxSvg = function XlsxSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5c0 .137.112.25.25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.78 6.427 17.073 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75h14.5a.75.75 0 0 0 .75-.75V6.957c0-.2-.078-.388-.22-.53M17 2.354 21.147 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#134A2C",
    d: "M19.5 15.5H18a.5.5 0 0 1 0-1h1.5a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "M16 15.5h-1.5a.5.5 0 0 1 0-1H16a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M19.5 13.5H18a.5.5 0 0 1 0-1h1.5a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M16 13.5h-1.5a.5.5 0 0 1 0-1H16a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M19.5 11.5H18a.5.5 0 0 1 0-1h1.5a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M16 11.5h-1.5a.5.5 0 0 1 0-1H16a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    d: "m4.76 16 1.924-3.008L4.921 10h1.42l.963 1.912q.132.272.182.406H7.5q.095-.218.199-.422L8.728 10h1.302l-1.81 2.975L10.075 16H8.69l-1.113-2.1a2 2 0 0 1-.132-.28h-.017a1.3 1.3 0 0 1-.128.271L6.154 16H4.759"
  }));
};
export var Xlsx = function Xlsx(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: XlsxSvg
  }));
};